// Utility for client-side compression/decompression using pako
import pako from "pako";

export function compressStringToGzip(str) {
    return pako.gzip(str);
}

export function decompressGzipToString(uint8Array) {
    try {
        return new TextDecoder().decode(pako.inflate(uint8Array));
    } catch (error) {
        console.error('Failed to decompress gzip data:', error);
        throw new Error(`Decompression failed: ${error.message}`);
    }
}

export function extractFilenameFromContentDisposition(contentDisposition) {
    if (!contentDisposition) return null;
    const normalized = contentDisposition.replace(/&quot;/g, '"');
    const match = normalized.match(/filename="([^"]+)"|filename=([^;\s]+)/);
    return match?.[1] || match?.[2] || null;
}
